import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom';
import { Row, Col, Divider } from 'antd'
import './ImpressaoPedido.scss';
import { Estoque } from '..';
import {  useAxios } from '../../hooks';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { usePedido } from '../../services/usePedidos';

const Vendedor = ({pedido}) => {
    if(pedido.vendedor && pedido.vendedor !== null){
        return (
            <Col span={3} className="dados vendedor">
                <h1>Vendedor</h1>
                <h2>{pedido.vendedor.nome}</h2>
            </Col>
        )
    } 
    return (<Col span={8} className="dados vendedor">            
                <h1>Vendedor</h1>
                <h2>N/D</h2>
            </Col>);
}

const Cliente = ({pedido}) => {
    const contato = (cliente) => {
        if(cliente.telefone || cliente.email){
            return (<>
                        <span className="label">CONTATO</span>
                        <span>{cliente.telefone}</span>
                        <span>{cliente.email}</span>
                   </>)
        }
        return <></>;
    }

    if(pedido.cliente){
        const cliente = pedido.cliente;
        const cpfCnpj = cliente.documento? cliente.documento.cpfCnpj : '';
        return (<>
                <Row className='form'>
                    <Col span={6} className={["dados", "cliente"]}>
                        <h1>Dados do Cliente</h1>
                        <h2>{cliente.nome}</h2>
                        <span>{cpfCnpj}</span>
                    </Col>

                    <Col span={6} className={["dados", "cliente"]}>
                        {contato(cliente)}
                    </Col>

                    <Col span={6} className={["dados", "cliente"]}>
                        <h1>Endereço</h1>
                        <span>{cliente.endereco || ''} {cliente.numero || 'S/N'}. {cliente.bairro || ''}</span>
                        <span>{cliente.complemento || ''}</span>
                        <span>
                            {
                                (() => {
                                    const cep = cliente.cep || '';
                                    const cidade = (cliente.cidade)? cliente.cidade.cidade || '' : '';
                                    const estado = (cliente.estado)? cliente.estado.uf || '' : '';

                                    let escrita = ``;
                                    if(cep){
                                        escrita += cep + ' ';
                                    }
                                    if(cidade){
                                        escrita += cidade + ' ';

                                        if(estado){
                                            escrita +=  '- ' + estado;
                                        }
                                    }
                                    return  escrita
                                })()
                            }
                           </span>
                    </Col>
                    <Col>
                        <Vendedor pedido={pedido}></Vendedor>
                    </Col>
                </Row>
                </>
            )
    }
    return <>
         <Row className='form'>
            <Col span={12} className={["dados", "cliente"]}>
                <h1>Dados do Cliente</h1>
                <h2>N/D</h2>                
            </Col>

            <Vendedor pedido={pedido}></Vendedor>
        </Row>
    </>;
}

const CabecalhoItensRomaneio = () => {
    return <Row className="cabecalhoItens">
        <Col span={5}>
            CÓDIGO
        </Col>
        <Col span={8}>
            DESCRIÇÃO
        </Col>
        <Col span={5} className="valores">
            QUANTIDADE
        </Col>
        <Col span={3} className="valores">
             {/* DESCONTOS - oculto no romaneio */}
        </Col>
        <Col span={3} className="valores">
             {/* TOTAL ITEM - oculto no romaneio */}
        </Col>
    </Row>
}

const CabecalhoServicosRomaneio = () => {
    return <Row className="cabecalhoItens">
        <Col span={13}>
            DESCRIÇÃO
        </Col>
        <Col span={5} className="valores">
            QUANTIDADE
        </Col>
        <Col span={3} className="valores">
             {/* DESCONTOS - oculto no romaneio */}
        </Col>
        <Col span={3} className="valores">
             {/* TOTAL Servico - oculto no romaneio */}
        </Col>
    </Row>
}

const ItemRomaneio = ({item}) => {
    return <Row className="item">
        <Col span={5}>
            {item.codigoProduto}
        </Col>
        <Col span={8}>
            {item.descricaoProduto}
        </Col>
        <Col span={5} className="valores">
            <Estoque value={item.quantidade} unMedida={(item && item.unidade) || "UN"}></Estoque>
        </Col>
        <Col span={3} className="valores">
             {/* (<Dinheiro value={item.totalDescontos}></Dinheiro>) - oculto no romaneio */}
        </Col>
        <Col span={3} className="valores">
             {/* <Dinheiro value={item.totalItem}></Dinheiro> - oculto no romaneio */}
        </Col>
    </Row>
}

const ItemServicoRomaneio = ({item}) => {
    return <Row className="item">
        <Col span={13}>
            {item.descricaoServico}
        </Col>
        <Col span={5} className="valores">
            <Estoque value={item.quantidade} unMedida={"UN"}></Estoque>
        </Col>
        <Col span={3} className="valores">
             {/* (<Dinheiro value={item.totalDescontos}></Dinheiro>) - oculto no romaneio */}
        </Col>
        <Col span={3} className="valores">
             {/* <Dinheiro value={item.totalServico}></Dinheiro> - oculto no romaneio */}
        </Col>
    </Row>
}

const ItensRomaneio = ({itens}) => {
    if(itens && itens !== null){
       return itens.map((item, index) => {
           const numItem = index + 1;
           if((numItem % 20) == 0){
               return (<ItemRomaneio item={item} key={item.id} className=""></ItemRomaneio>)
           }
           return (<ItemRomaneio  key={item.id} item={item}></ItemRomaneio>)
        });
    }
    return <></>
}   

const ItensServicoRomaneio = ({itens}) => {
    if(itens && itens !== null){
       return itens.map((item, index) => {
           const numItem = index + 1;
           if((numItem % 20) == 0){
               return (<ItemServicoRomaneio item={item} key={item.id} className=""></ItemServicoRomaneio>)
           }
           return (<ItemServicoRomaneio key={item.id} item={item}></ItemServicoRomaneio>)
        });
    }
    return <></>
}   

const ProdutosRomaneio = ({pedido}) => {
    const cabecalho = () => {
        return (
        <>
            <Divider orientation="left" className="dividerProdutos"></Divider>
            <Row className='form'>
                <Col span={24} className="dados">
                    <h1>Produtos</h1>
                </Col>
            </Row>
        </>);
    }

    if(pedido && pedido.itens && pedido.itens.length){
        return <>
            {cabecalho()}
            <div className="itens-wrapper">
                <CabecalhoItensRomaneio></CabecalhoItensRomaneio>
                <ItensRomaneio itens={pedido.itens}></ItensRomaneio>
            </div>
        </>
    } 
    return <></>;
}

const ServicosRomaneio = ({pedido})=>{
    const cabecalho = () => {
        return (
        <>
            <Divider orientation="left" className="dividerProdutos"></Divider>
            <Row className='form'>
                <Col span={24} className="dados">
                    <h1>Serviços</h1>
                </Col>
            </Row>
        </>);
    }

    if(pedido && pedido.servicos && pedido.servicos.length){
        return <>
            {cabecalho()}
            <div className="itens-wrapper">
                <CabecalhoServicosRomaneio></CabecalhoServicosRomaneio>
                <ItensServicoRomaneio itens={pedido.servicos}></ItensServicoRomaneio>
            </div>
        </>
    } 
    return <></>;
}

const Logotipo = ({logotipo}) => {
    if(logotipo){
        return <Col flex={"3cm"}>
            <span className="logotipo">
                <img 
                    src={logotipo} 
                    alt="logotipo"
                    style={{width: "3cm"}}
                ></img>
            </span>
        </Col>
    }
    return <></>
}

const Empresa = ({empresa}) => {
    let nome = empresa?.nomeFantasia || empresa?.razaoSocial || "";
    nome = nome.substr(0, 95);
    if(empresa){
        return ([
                <Logotipo logotipo={empresa.logotipo}></Logotipo>,
                <Col flex={"calc(100% - 7cm)"}>
                    <span className="nome" style={{display: "block"}}>{nome}</span>
                    <span className="cnpj" style={{display: "block"}}>{empresa.cnpj}</span>
                    <span className="contato" style={{display: "block"}}>{empresa.telefone} | {empresa.email} </span>
                    <span className="endereco"  style={{display: "block"}}>{empresa.endereco.CEP} - {empresa.endereco.logradouro} {empresa.endereco.nro} {empresa.endereco.complemento}, {empresa.endereco.bairro} - {empresa.endereco.cidade.cidade} {empresa.endereco.estado.uf} </span>
                </Col>
            ])
    } 
    return (<Col span={12}></Col>) 
}

const Observacoes = ({pedido}) => {
    return (<div className="obs-wrapper">
        <Row>
            <Col span={24}>
                <span className="label">Observações</span>
            </Col>
        </Row>
        <Row>
            <Col className='obs'>{pedido.obs || "N/D"}</Col>
        </Row>
    </div>);
}

const DescricaoOS = ({pedido, className=""})=>{
    return <Row className={["form", className, "descricaoOS"]}>
        <Col span={24} className="dados">
            <h1>Dados da OS</h1>
            <span>
                {pedido.descricao}
            </span>
        </Col>
    </Row>
}

const ImpressaoRomaneio = ({pedido, onReady = () => {}}) => {
    const reducerTermosUso = useSelector((state) => state.reducerTermosUso);
    const {buscaTermosUso} = usePedido();
    const {termosUso} = reducerTermosUso;
    const dispatch = useDispatch();
    const {getApiEmitirNotas} = useAxios();
    const [empresa, setEmpresa] = useState();

    useEffect(()=> {
        if (pedido && pedido.id && empresa) {
            onReady();
        }
    }, [pedido, empresa, onReady]);

    useEffect(()=> {
        defineEmpresa();
    }, [true]);

    useEffect(()=> {
        realizaBuscaTermosUso();
    }, [true]);

    const defineEmpresa = async () => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/empresa');
        setEmpresa(result.data);
    }

    const realizaBuscaTermosUso = async ()=> {
        const termosUso = await buscaTermosUso();
        dispatch({type: "setTermosUso", payload: termosUso} );
    }

    if(!pedido || !pedido.id) {
        return <></>;
    }

    let elementoImpressao;
    if(empresa){
        elementoImpressao = (<ImpressaoRomaneioCompleto empresa={empresa}  pedido={pedido}></ImpressaoRomaneioCompleto>)
    }

    // Garante que o elemento #print existe antes de tentar renderizar
    let printElm = document.getElementById('print');
    if (!printElm) {
        printElm = document.createElement('div');
        printElm.id = 'print';
        printElm.className = 'print';
        document.body.appendChild(printElm);
    }
    
    return ReactDOM.createPortal(
        elementoImpressao,
        printElm
    );
}

const ImpressaoRomaneioCompleto = ({pedido, empresa}) => {
    let tagServicos = <></>;
    let tagDescricaoOS = <></>;
    let tituloPedido = "ROMANEIO - PEDIDO";

    if(pedido.tipoPedido == "ORDEM_SERVICO"){
        tagServicos = <ServicosRomaneio pedido={pedido}></ServicosRomaneio>;
        tagDescricaoOS = <DescricaoOS pedido={pedido}></DescricaoOS>;
        tituloPedido = "ROMANEIO - OS";
    }
    
    return (<div className='wrapperImpressao'>
                <div id='impressaoPedido'>
                    <table style={{width: "100%"}}>
                        <thead>
                            <tr>
                                <td>
                                <Row className='cabecalho' id="cabecalhoImpressao">
                                    <Empresa empresa={empresa}></Empresa>
                                    <Col flex={"3cm"}>
                                        <h1><span className={"status"}>{pedido.status}</span> | {tituloPedido} {pedido.numeroPedido}</h1> 
                                        <span className="status">DATA {tituloPedido.split(' ')[2] || 'PEDIDO'}: {moment(pedido.dataAbertura).format("DD/MM/YYYY")}</span>
                                        <span className="pageNumber"></span>
                                    </Col>
                                </Row>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <Cliente pedido={pedido}></Cliente>
                                    {tagDescricaoOS}
                                    <ProdutosRomaneio pedido={pedido}></ProdutosRomaneio>   
                                    {tagServicos}
                                    <Observacoes pedido={pedido}></Observacoes> 
                                </td>
                            </tr>
                        </tbody>
                        <tfoot style={{
                            display: "table-row-group"
                        }}>
                            <tr>
                                <td>
                                    <div style={{
                                        marginTop: "2cm",
                                        textAlign: "center",
                                        fontSize: "10pt",
                                        fontWeight: "bold"
                                    }}>
                                        <span>ROMANEIO - DOCUMENTO SEM VALOR FISCAL</span>
                                    </div>         
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
    )
};

export {ImpressaoRomaneio};
